import CryptoJS from "crypto-js";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import BookingService from "./../../../services/cargobooking.service";
import VueElementLoading from "vue-element-loading";
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';

export default {
  name: "basicinformation",
  components: {
    highcharts: Chart,
    // HighchartsSolidGauge,
    VueElementLoading,
    Highcharts,
  },

  data() {
    return {
      isLoading: false,
      counters: "",
      bookingmethod: "",
      originhub: "",
      piechart: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: "Total Count",
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },

        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            // colors: this.pieColors,
            size: 250,
            point: {
              events: {
                click: (e) => {
                  this.pieClickedFun(e);
                },
              },
            },

            dataLabels: {
              enabled: true,
              //format: '<b>{point.name}</b><br>{point.percentage:.1f} %',
              format: "<b>{point.name}</b>: <br>{point.y} ",
              distance: -50,
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
            },
          },
        },

        credits: {
          enabled: false,
        },
        series: [
          {
            name: "",
            data: [
              { name: "Rapid", y: 0, color: "#7393B3" },
              { name: "Complete", y: 0, color: "#088F8F" },
              { name: "Invalid", y: 0, color: "#0096FF" },
              // { name: 'web', y: 6765, color: '#869ef6' },
              // { name: 'Upload', y: 4765, color: '#0072f0' }
            ],
          },
        ],
      },

      barchart: {
        chart: {
          type: "column",
        },
        title: {
          text: "Booking",
        },
        subtitle: {
          text: "",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Booking Counts",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },

            point: {
              events: {
                click: this.barClickedFun.bind(this),
              },
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>',
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Bookings",
            colorByPoint: true,
            data: [],
          },
        ],
        drilldown: {
          breadcrumbs: {
            position: {
              align: "right",
            },
          },
        },
      },

      barchart2: {
        chart: {
          type: "column",
        },
        title: {
          text: "Rapid vs Complete",
        },
        subtitle: {
          text: "",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          categories: ["Total", "App", "Web", "CSV"]
        },
        yAxis: {
          title: {
            text: "Booking Count",
          },
        },
        legend: {
          enabled: true,
          verticalAlign: 'top',
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },

            point: {
              events: {
                click: this.barClickedFunRapidvsComplete.bind(this),
              },
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>',
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Bookings",
            colorByPoint: true,
            data: [],
          },
        ],
        drilldown: {
          breadcrumbs: {
            position: {
              align: "right",
            },
          },
        },
      },


      totalchart: {
        chart: {
          type: "column",
        },
        title: {
          text: "Booking Performance",
        },
        subtitle: {
          text: "",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Booking count",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },

            point: {
              events: {
                // click: this.barClickedFun.bind(this),
              },
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> of total<br/>',
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Bookings",
            colorByPoint: true,
            data: [],
          },
        ],
        drilldown: {
          breadcrumbs: {
            position: {
              align: "right",
            },
          },
        },
      },
      buttonselected: 'day',
      fromdate: '',
      todate: '',
      isDummyHub: false,
      imagearray :[]
    };
  },

  async mounted() {

    var userdetailEncrypt = window.localStorage.getItem(
      "cargoAutoaccessuserdata"
    );
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.userRoleFlag = (userdetail.rolename[0] == "Hub Executive" || userdetail.rolename[0] == "Hub Incharge" || userdetail.rolename[0] == "Hub Manager" || userdetail.rolename[0] == "TSP BA Admin")?1:2;
    if (this.userRoleFlag == 1) {
      this.originhub = userdetail.hubID[0];
    }
    this.originhub = userdetail.hubID[0];
    this.isDummyHub = this.originhub == 516 ? true :false
    await this.getBookingCountData();
  },
  async beforeDestroy() {
    clearInterval(this.counters);
  },
  methods: {
    barClickedFun(data) {
      let query = {
        BookingFromDate : this.fromdate, BookingToDate : this.todate, Origin: this.originhub
      }
      if(data.point.options.drilldown != 'Total') {
        query.BookingMethod = data.point.options.name
      }
      this.$router.replace({
        path: "/Booking",
        query: query,
      });
    },
    barClickedFunRapidvsComplete(data) {
      let query ={}
      if( data.point.options.drilldown == 'Total' ) {
        query = { BookingStatus: data.point.options.name }
      } else {
        let bookingMethod = data.point.options.drilldown == 'CSV' ? 'Upload' : data.point.options.drilldown;
        query = { BookingMethod: bookingMethod, BookingStatus: data.point.options.name }
      }
      query.BookingFromDate = this.fromdate;
      query.BookingToDate = this.todate;
      query.Origin = this.originhub;
      this.$router.replace({
        path: "/Booking",
        query: query,
      });
    },
    pieClickedFun(e) {
      this.$router.replace({
        path: "/Booking",
        query: { BookingStatus: e.point.options.name },
      });
    },
    async getBookingCountData() {
      try {
        this.isLoading = true;
        let InputPayload = {};

        InputPayload.originhub = this.originhub;
        InputPayload.filter = this.buttonselected;
        let result = await BookingService.getBookingCount(
          InputPayload
        );

        this.fromdate = result.data.data.fromdate;
        this.todate = result.data.data.todate;
        let BookingCount = result.data.data.booking
        let x = [
          parseInt(BookingCount.total),
          parseInt(BookingCount.web),
          parseInt(BookingCount.app),
          parseInt(BookingCount.api),
          parseInt(BookingCount.upload),
        ];
        let bname = ["Total", "Web", "App", "API", "Upload"];
        let drilldown = ["Total", "Web", "App", "API", "Upload"];
        var bcolor = "#7393B3"
        let barChartDataObj = {};
        this.barchart.series.map((chart) => {
          chart.data = [];
        });
        for (let i = 0; i < x.length; i++) {
          barChartDataObj.y = parseFloat(x[i]);
          barChartDataObj.name = bname[i];
          barChartDataObj.drilldown = drilldown[i];
          barChartDataObj.color = bcolor;
          console.log(barChartDataObj);
          this.barchart.series.map((chart) => {
            chart.data.push(barChartDataObj);
          });
          barChartDataObj = {};
        }

        // Rapid vs Complete
        let BookingCountRapid = result.data.data.bokingtype.rapid
        let BookingCountComplete = result.data.data.bokingtype.complete
        let xRapid = [
          parseInt(BookingCountRapid.total),
          parseInt(BookingCountRapid.app),
          parseInt(BookingCountRapid.web),
          parseInt(BookingCountRapid.upload),
        ];
        let xComplete = [
          parseInt(BookingCountComplete.total),
          parseInt(BookingCountComplete.app),
          parseInt(BookingCountComplete.web),
          parseInt(BookingCountComplete.upload),
        ];
        let bname2 = ["Total", "App", "Web", "CSV"];
        let drilldown2 = ["Total", "App", "Web", "CSV"];
        var bcolorRapid = "#7393B3";
        var bcolorComplete = "#3d5d7d";

        let barChartRapidData = []
        let barChartRapid ={};
        let barChartCompleteData =[];
        let barChartComplete ={};
        for (let i = 0; i < xRapid.length; i++) {
          barChartRapid.y = parseFloat(xRapid[i]);
          barChartRapid.name = "Rapid";
          barChartRapid.drilldown = bname2[i];
          barChartRapid.color = bcolorRapid;
          barChartRapidData.push(barChartRapid);
          barChartRapid = {};
        }
        for (let i = 0; i < xComplete.length; i++) {
          barChartComplete.y = parseFloat(xComplete[i]);
          barChartComplete.name = "Complete";
          barChartComplete.drilldown = bname2[i];
          barChartComplete.color = bcolorComplete;
          barChartCompleteData.push(barChartComplete);
          barChartComplete = {};
        }
        this.barchart2.series = [
          {
            type: 'column',
            name: 'Rapid',
            color: bcolorRapid,
            data: barChartRapidData
          }, {
            type: 'column',
            name: 'Complete',
            color: bcolorComplete,
            data: barChartCompleteData
          }
        ];

        // Booking Performance
        let BookingPerformanceCount = result.data.data.performance
        let xPerfomance = [];
        let xCategory = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
        barChartDataObj = {};
        let monthlist=[]
        this.totalchart.series.map((chart) => {
          chart.data = [];
        });
        for (let item in BookingPerformanceCount) {
          monthlist.push(parseInt(item.split("-")[0]+item.split("-")[1].padStart(2, "0")))
        }
        monthlist.sort((a,b) => a - b);
        for(let i = 0; i < monthlist.length; i++) {
          let year = String(monthlist[i]).slice(0,4);
          let month = String(monthlist[i]).slice(4);
          month = month[0] == '0' ? month =month.slice(1) : month
          barChartDataObj.y = parseFloat(BookingPerformanceCount[year+"-"+month]);
          barChartDataObj.name = year + "-" + xCategory[parseInt(month)];
          barChartDataObj.drilldown = year + "-" + xCategory[parseInt(month)];
          barChartDataObj.color = "#7393B3";
          this.totalchart.series.map((chart) => {
            chart.data.push(barChartDataObj);
          });
          barChartDataObj = {};
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.$alertify.error("Internal server error.");
        console.log(err)
      }
    },
    getFilterData(filter) {
      this.buttonselected = filter;
      this.getBookingCountData();
    },
    //Test Code to check POD images cross account issue
    async handleFileUpload(event) {
      let uploadFile = event.target.files;
      this.imagearray = []
        let formData = new FormData();
        /*Add the form data we need to submit*/
        for (let key in uploadFile) {
          if(key >= 0 ){
            if(uploadFile[key].type != "image/jpeg" &&
          uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png")
          {
            this.$alertify.error("Please upload only valid file format");
            return false
          }
          }
          if (key == 'length' && uploadFile[key] > 3) {
            this.$alertify.error("Please upload maximum 3 file");
            return false
          }
          if (uploadFile[key].size > (1024 * 1024 * 3)) {
            this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
            return false
          } else {
            formData.append("file", uploadFile[key]);
          }
        }
        formData.append("awb", '94925822092022');
        let result = await TripServices.UploadPODImageTest(formData)
        if (result.data.code == 200) {
          result.data.data.map(obj => {
            this.imagearray.push(obj.Location)
          })
          console.log("Uploaded pod Response", result);
          this.$alertify.success("Images uploaded successfully !");
        }
        else {
          console.log("Pod image not uploaded", result);
          this.$alertify.error("Images could not be uploaded.");
        }
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/bookingdashboard/bookingdashboard.component.js